import React from "react"

import "filepond-polyfill"
import { FilePond, registerPlugin } from "react-filepond"
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginValidateSize from 'filepond-plugin-file-validate-size'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

registerPlugin(
  FilePondPluginImagePreview,
  FilePondPluginValidateSize,
  FilePondPluginValidateType
)

const RequiredTag = () => (
  <small className="text-muted">&nbsp;(required)</small>
)

export const FormFieldInput = props => (
  <div className="form-group mb-4">
    <label htmlFor={props.name + "_id"}>
      {props.labelText}
      {props.required ? <RequiredTag /> : null}
    </label>
    <input
      type={props.type}
      className="form-control"
      disabled={props.disabled ? true : false}
      id={props.name + "_id"}
      aria-describedby={props.name + "_help"}
      placeholder={props.placeholder}
      name={props.name}
      value={props.value || ''}
      onChange={props.onChange}
      required={props.required}
    />
    {props.helpText ?
      <small id={props.name + "_help"} className="form-text text-muted">
          {props.helpText}
      </small> : null
    }
  </div>
)

export const FormFieldTextArea = props => (
  <div className="form-group mb-4">
    <label htmlFor={props.name + "_id"}>
      {props.labelText}
      {props.required ? <RequiredTag/> : null}
    </label>
    <textarea
      className="form-control"
      disabled={props.disabled ? true : false}
      id={props.name + "_id"}
      aria-describedby={props.name + "_help"}
      placeholder={props.placeholder}
      name={props.name}
      value={props.value || ''}
      onChange={props.onChange}
      rows="5"
      required={props.required}
    />
    {props.helpText ?
      <small id={props.name + "_help"} className="form-text text-muted">
          {props.helpText}
      </small> : null
    }
  </div>
)

export const FormFieldDropdown = props => (
  <div className="form-group mb-4">
    <label htmlFor={props.name + "_id"}>
      {props.labelText}
      {props.required ? <RequiredTag /> : null}
    </label>
    <select
      className="form-control"
      disabled={props.disabled ? true : false}
      id={props.name + "_id"}
      aria-describedby={props.name + "_help"}
      name={props.name}
      value={props.value || ''}
      onChange={props.onChange}
      required={props.required}
    >
      {props.children}
    </select>
    {props.helpText ?
      <small id={props.name + "_help"} className="form-text text-muted">
          {props.helpText}
      </small> : null
    }
  </div>
)


export const FormFieldFile = props => (
  <div className="form-group mb-4">
    <label className="mr-3">
      {props.labelText}
      {props.required ? <RequiredTag/> : null}
    </label>
    <div style={{maxWidth: '40rem'}}>
      <FilePond
        allowMultiple={props.allowMultiple ? props.allowMultiple : true}
        maxFiles={props.maxFiles ? props.maxFiles : 10}
        acceptedFileTypes={props.acceptedFileTypes ? props.acceptedFileTypes : ['image/*']}
        maxFileSize={props.maxFileSize ? props.maxFileSize : '5MB'}
        disabled={props.disabled ? true : false}
        name={props.name}
        onChange={props.onChange}
        required={props.required}
        server={`${process.env.GATSBY_API_URL}/api/upload/`}
        onprocessfile={props.handleProcessFile}
        onprocessfiles={props.handleProcessFiles}
        onremovefile={props.handleRemoveFile}
        files={props.files}
      />
    </div>
    {props.helpText ?
      <small id={props.name + "_help"} className="form-text text-muted">
          {props.helpText}
      </small> : null
    }
  </div>
)
